/* ------------------------------------------------------------------
   小样「最多 10 片」的统一提示。

   在这之前，三个加小样的入口在数满 10 片后都是静默 return：
   - assets/products-grid-swatch.js       小样落地页 / 搜索结果页的色块和弹窗
   - assets/products-grid-swatchpopup.js  窗帘产品页的取样弹窗
   - assets/page_product_gallery.js       小样产品页（按钮直接禁用，同样没说为什么）
   用户点了没反应，也不知道是坏了还是到上限了。

   这里只提供一个函数，谁被拦下谁调：window.swatchLimitNotice()。
   提示节点由 snippets/swatch-limit-toast.liquid 渲染，文案走主题设置，
   所以这个文件里不写任何文案 —— 找不到节点就安静退出，不影响原有加购流程。

   不用原生 alert：alert 会阻塞、样式不可控，而且在弹窗里点掉之后
   焦点会跳出取样弹窗。
   ------------------------------------------------------------------ */
(function () {
  var VISIBLE_MS = 5000;
  var FADE_MS = 250;
  var showTimer = null;
  var hideTimer = null;

  function toast() {
    return document.querySelector('[data-swatch-limit-toast]');
  }

  function hide() {
    var el = toast();
    if (!el) return;
    if (showTimer) {
      clearTimeout(showTimer);
      showTimer = null;
    }
    el.classList.remove('is-visible');
    if (hideTimer) clearTimeout(hideTimer);
    // 等淡出动画走完再 hidden，否则会瞬间消失
    hideTimer = setTimeout(function () {
      el.hidden = true;
      hideTimer = null;
    }, FADE_MS);
  }

  // 加购失败专用。**不要**为了这个去调 swatchLimitNotice(why)：
  // 断网 / 超时 / 返回非 JSON 时 why 是空的，swatchLimitNotice 会回落到
  // "你已经加满 10 片"这句 —— 而用户购物车里可能一片都没有，纯属误导。
  // 这里空值回落到通用文案，且**永远不把底层异常字符串**（SyntaxError、
  // Failed to fetch 之类）丢给用户看。
  window.swatchAddError = function (message) {
    var el = toast();
    var generic = (el && el.getAttribute('data-generic-error'))
      || 'We could not add this swatch. Please try again.';
    window.swatchLimitNotice(message || generic);
  };

  // message 可选：不传就用主题设置里的上限文案；
  // 加购被 Shopify 拒绝（422 售罄/无效变体等）时传服务端给的原因。
  window.swatchLimitNotice = function (message) {
    var el = toast();
    if (!el) return;

    var textEl = el.querySelector('.swatch-limit-toast__text');
    if (textEl) {
      if (!textEl.dataset.defaultText) textEl.dataset.defaultText = textEl.textContent;
      textEl.textContent = message || textEl.dataset.defaultText;
    }
    // 报加购失败时"去看看我的小样"这个链接没有意义
    var linkEl = el.querySelector('.swatch-limit-toast__link');
    if (linkEl) linkEl.hidden = !!message;

    bindHover(el);

    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }
    el.hidden = false;
    // 连点两次时重新触发一遍淡入：先摘掉类，强制重排，再加回去
    el.classList.remove('is-visible');
    void el.offsetWidth;
    el.classList.add('is-visible');

    if (showTimer) clearTimeout(showTimer);
    showTimer = setTimeout(hide, VISIBLE_MS);
  };

  // 鼠标停在上面或者焦点进到里面时，别把它收走。
  // 提示里有"Review my swatches"链接和关闭按钮，5 秒到点就消失的话，
  // 键盘用户正 Tab 到一半目标就没了。移开/失焦后重新开始计时。
  //
  // ⚠ 这里必须**直接绑在提示元素上**，不能用 document 上的捕获阶段委托。
  // mouseenter/mouseleave 绑在元素上时只认"进出这个元素（含后代）"，
  // 但在捕获阶段做委托会把每个后代的进出都收进来：
  // 鼠标从链接移到提示的空白处，会触发链接的 mouseleave 从而重新起表，
  // 而提示本身不会再触发一次 mouseenter —— 结果人还在提示上，计时器已经重启了。
  var hoverBound = false;
  function bindHover(el) {
    if (hoverBound || !el) return;
    hoverBound = true;
    el.addEventListener('mouseenter', function () {
      if (showTimer) {
        clearTimeout(showTimer);
        showTimer = null;
      }
    });
    el.addEventListener('mouseleave', function () {
      if (el.hidden) return;
      if (showTimer) clearTimeout(showTimer);
      showTimer = setTimeout(hide, VISIBLE_MS);
    });
  }

  document.addEventListener('focusin', function (event) {
    if (event.target.closest && event.target.closest('[data-swatch-limit-toast]') && showTimer) {
      clearTimeout(showTimer);
      showTimer = null;
    }
  });

  document.addEventListener('focusout', function (event) {
    var el = toast();
    if (!el || el.hidden) return;
    if (event.target.closest && event.target.closest('[data-swatch-limit-toast]')) {
      // 焦点还在提示内部就不算离开
      if (el.contains(event.relatedTarget)) return;
      if (showTimer) clearTimeout(showTimer);
      showTimer = setTimeout(hide, VISIBLE_MS);
    }
  });

  // 事件委托：提示节点可能在筛选重渲染之后才出现
  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    if (event.target.closest('[data-swatch-limit-toast] .swatch-limit-toast__close')) {
      hide();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') hide();
  });
})();
